function search() {

    if ( $('input#site-search').length ) {
        const $searchField = $('input#site-search'),
              $searchResultsList = $('.search-results__list .container'),
              $inputCont = $('.search-input__cont');

        // Wait 250ms after keyup to fire search
        const delay = 250;
        let timer;
        $searchField.keyup(function() {
            clearTimeout(timer);
            timer = setTimeout(x => {
                doSearch();
            }, delay);
        });

        // AJAX Search request
        function doSearch() {
            const searchVal = $searchField.val();
            $inputCont.addClass('loading');
            $.ajax({
                type: 'POST',
                url: theme_vars.ajax_url,
                dataType: 'json',
                data: {
                    action: 'site_search',
                    search: searchVal,
                },
                success: function(result) {
                    $searchResultsList.html(result.posts);
                },
				complete: function() {
					$inputCont.removeClass('loading');
				}
            });
        }
        
    }
}